import React, { useState } from 'react';
import axios from 'axios';
import './GestionesMasivas.css';

const ExcelUpload = ({ token }) => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      setMessage('Por favor, selecciona un archivo Excel.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await axios.post('Acreditados/CargaMasivaGestiones', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`, // Incluye el token en el encabezado
        },
      });

      if (response.data.success) {
        setMessage('Archivo subido y procesado exitosamente.');
      } else {
        setMessage('Hubo un error al procesar el archivo: ' + response.data.message);
      }
    } catch (error) {
      console.error('Error al subir el archivo:', error);
      setMessage('Hubo un error al procesar el archivo.');
    }
  };

  return (
    <section className='GestionesMasivas_Container'>
      <div className="form-wrapper">
        <h2>Subir Archivo Excel</h2>
        <form onSubmit={handleSubmit}>
          <input type="file" onChange={handleFileChange} accept=".xls,.xlsx" />
          <small className="file-restriction">Solo se permiten archivos con extensiones .xls, .xlsx</small>
          <button type="submit">Subir</button>
        </form>
        {message && <p>{message}</p>}
      </div>
    </section>
  );
};

export default ExcelUpload;
